export * from './error.component'